import { useContext } from "react";
import NavigationProviderContext from "./NevigationProvider";

function Link({to, children}){
    const {nevigate} = useContext(NavigationProviderContext);

    const handleClick = (event) => {
        if (event.metaKey || event.ctrlKey) {
            return;
        }

        event.preventDefault();
        window.scrollTo(0, 0);

        document.querySelector(".hamburger-link").classList.remove('open');
        nevigate(to);
    }

    return(
        <a onClick={handleClick} href={to} style={{color: 'black', textDecoration: 'none'}}>{children}</a>
    );
}
export default Link;
